import angular from 'angular';
import NotificationController from './model/notification';

export default angular.module('app')
	.controller('NotificationController', NotificationController);
